const initializeDropInBlogCTA = () => {
  var config = window.dropinblogCtaConfig;
  
  if (!config || !config.enable) {
    return;
  }
  
  var path = window.location.pathname;
  var isDropInBlogArticle = path.indexOf('/a/blog/') !== -1;
  var isShopifyBlogArticle = path.indexOf('/blogs/') !== -1 && path.split('/').length >= 4;

  if (!isDropInBlogArticle && !isShopifyBlogArticle) {
    return;
  }

  var attempts = 0;
  var maxAttempts = 60;

  var checkFooter = setInterval(function () {
    attempts++;
    var footer = document.querySelector('#shopify-section-static-footer') || document.querySelector('footer');
    var main = document.querySelector('#site-main');

    if (footer && main) {
      clearInterval(checkFooter);

      if (document.querySelector('[data-dropinblog-cta]')) {
        return;
      }

      var ctaWrapper = document.createElement('div');
      ctaWrapper.setAttribute('data-dropinblog-cta', '');
      ctaWrapper.className = 'dropinblog-cta-section dropinblog-cta-width-' + config.contentWidth;
      
      var bgStyle = '';
      if (config.backgroundImage) {
        bgStyle = 'background-image: url(' + config.backgroundImage + '); background-size: cover; background-position: center;';
      }

      ctaWrapper.setAttribute('style', 
        '--cta-top-pad: ' + config.topPadding + 'px;' +
        '--cta-bottom-pad: ' + config.bottomPadding + 'px;' +
        '--cta-desktop-align: ' + config.desktopAlignment + ';' +
        '--cta-mobile-align: ' + config.mobileAlignment + ';' +
        bgStyle
      );

      var overlayHtml = config.backgroundImage ? '<div class="dropinblog-cta-overlay"></div>' : '';
      var headingSizeClass = 'dropinblog-cta-heading--' + config.headingSize;
      
      var headingHtml = config.heading ? '<h2 class="dropinblog-cta-heading ' + headingSizeClass + '">' + config.heading + '</h2>' : '';
      var descHtml = config.description ? '<div class="dropinblog-cta-description">' + config.description.replace(/\n/g, '<br>') + '</div>' : '';

      var targetAttr = config.buttonNewTab ? ' target="_blank" rel="noopener noreferrer"' : '';
      
      // Based on the reference image, button has a map icon inside it or next to it. Let's put the map icon in the button and the arrow at the end.
      var buttonHtml = (config.buttonText && config.buttonLink) ? 
        '<a href="' + config.buttonLink + '" class="dropinblog-cta-button button-primary"' + targetAttr + '>' + 
          '<span class="dropinblog-cta-button-text-wrapper">' +
            '<span class="dropinblog-cta-button-map-icon">' + config.icons.map + '</span>' + 
            '<span class="dropinblog-cta-button-text">' + config.buttonText + '</span>' + 
          '</span>' +
          '<span class="dropinblog-cta-button-arrow">' + config.icons.rightArrow + '</span>' + 
        '</a>' : '';

      var disclaimerHtml = (config.disclaimerEnabled) ? 
        '<div class="dropinblog-cta-support-truck"><span class="dropinblog-cta-support-icon">' + config.icons.truck + '</span><span>' + (config.disclaimer ? config.disclaimer.replace(/\n/g, '<br>') : '') + '</span></div>' : '';
      
      ctaWrapper.innerHTML = overlayHtml + '<div class="dropinblog-cta-container">' + 
        '<div class="dropinblog-cta-inner">' +
          headingHtml +
          descHtml +
          '<div class="dropinblog-cta-action-area">' +
             buttonHtml +
             '<div class="dropinblog-cta-supporting">' +
               disclaimerHtml +
             '</div>' +
          '</div>' +
        '</div>' +
      '</div>';

      // Insert after the main content, before footer
      footer.parentNode.insertBefore(ctaWrapper, footer);
    }
    
    if (attempts >= maxAttempts) {
      clearInterval(checkFooter);
    }
  }, 500);
};

window?.blObjects?.runFunction(() => {
  initializeDropInBlogCTA();
  document.addEventListener("shopify:section:load", initializeDropInBlogCTA);
});
